import { createAction, props } from '@ngrx/store';
import {
  IPerformance,
  AssetPerformanceRequest,
  IPerformanceDataResult,
  IAssetPerformanceDataResult,
  PerformanceSettings,
} from './../../../models/performance';

export const loadPerformanceData = createAction(
  '[Performance] Load Performance Data',
  props<{ payload: IPerformance }>()
);

export const performanceDataLoaded = createAction(
  '[Performance] Performance Data Loaded',
  props<{ payload: IPerformanceDataResult }>()
);

export const loadAssetPerformanceData = createAction(
  '[Asset Performance] Load Asset Performance Data',
  props<{ payload: AssetPerformanceRequest }>()
);

export const loadAssetClassificationPerformanceData = createAction(
  '[Asset Classification Performance] Load Asset Classification Performance Data',
  props<{ payload: AssetPerformanceRequest }>()
);

export const assetPerformanceDataLoaded = createAction(
  '[Asset Performance] Asset Performance Data Loaded',
  props<{ payload: IAssetPerformanceDataResult }>()
);

export const assetClassificationPerformanceDataLoaded = createAction(
  '[Asset Classification Performance] Asset Classification Performance Data Loaded',
  props<{ payload: IAssetPerformanceDataResult }>()
);


export const updatePerformanceSettings = createAction(
  '[Performance] Update Performance Settings',
  props<{ settings: PerformanceSettings }>()
);

export const updatePerformanceSettingsWithoutReload = createAction(
  '[Performance] Update Performance Settings Without Reloading',
  props<{ settings: PerformanceSettings }>()
);

export const clearPerformanceState = createAction(
  '[Performance] Clear State',
  props<{ settings : PerformanceSettings }>()
);

export const performanceDataError = createAction(
  '[Performance] Data Error',
  props<{ errorMessage: string }>()
);

export const assetPerformanceDataError = createAction(
  '[Asset Performance] Data Error',
  props<{ errorMessage: string }>()
);

export const assetClassificationPerformanceDataError = createAction(
  '[Asset Classification Performance] Data Error',
  props<{ errorMessage: string }>()
);